import { getCalendarEntryByCalendarId } from 'owa-calendar-cache';
import {
    RenameCalendarDocument,
    RenameCalendarMutation,
    RenameCalendarMutationVariables,
} from '../graphql/__generated__/renameCalendarMutation.interface';
import { getApolloClient } from 'owa-apollo';
import type * as Schema from 'owa-graph-schema';

export type RenameCalendarResultType = RenameCalendarMutation['renameCalendar'];

/**
 * Renames calendar on server
 * @param calendarId the id of the calendar
 * @param newCalendarName new calendar name
 */
export default async function renameCalendarService(
    calendarId: Schema.CalendarId,
    newCalendarName: string
): Promise<RenameCalendarResultType> {
    const calendarEntry = getCalendarEntryByCalendarId(calendarId.id) as Schema.CalendarsUnionType;
    const renameCalendarMutationInput: RenameCalendarMutationVariables = {
        calendarId: {
            id: calendarId.id,
            changeKey: calendarId.changeKey,
            mailboxInfo: calendarId.mailboxInfo,
        },
        newCalendarName: newCalendarName,
        calendarTypename: calendarEntry.__typename,
    };

    const client = await getApolloClient();
    const result = await client.mutate({
        variables: renameCalendarMutationInput,
        mutation: RenameCalendarDocument,
    });

    return result?.data?.renameCalendar;
}
